import { CSSProperties } from 'react';

import { defaultSeparation, spacing } from '~/ui/styles/defaults';

export const tableStyle: CSSProperties = {
  marginTop: defaultSeparation,
  marginBottom: spacing * 10,
};
